import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography, Button } from '@material-ui/core';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
// import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MicIcon from '@material-ui/icons/Mic';
// import SearchIcon from '@material-ui/icons/Search';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Rating from './Rating';
import RadioOptions from './RadioOptions';
import usePersistedState from './usePersistedState';
// import PeerInvest from './PeerInvestDatePicker';
import PeersTable from './PeersTable';
import FeedbackPDF from './FeedbackPDF';

import logoDrivee from '../../assets/images/LogoDrivee.jpg';
import StrWeakTable from './StrWeakTable';
import InfluenceValuationTable from './InfluenceValuationTable';

const animatedComponents = makeAnimated();

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, '')
});

const useStyles = makeStyles((theme) => ({
  container: {
    width: '85%',
    margin: '0 auto'
  },
  textContainer: {
    margin: '1.5rem 0'
  },
  paperContainer: {
    padding: '1rem 4rem'
  },
  text: {
    fontFamily: 'PT sans',
    fontSize: '14px'
  },
  desc: {
    fontFamily: 'PT serif',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#252525',
    margin: '1rem 0'
  },
  instructions: {
    fontFamily: 'PT sans',
    fontSize: '16px'
  },
  valueInfo: {
    marginBottom: '2.5rem'
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  inputStrWeak: {
    marginTop: '.5rem',
    marginRight: '1rem',
    width: '35ch'
  },
  inputs: {
    display: 'flex',
    marginTop: '1.5rem',
    width: '100%'
  },
  strweak: {
    marginBottom: 3,
    display: 'block',
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#252525'
  },
  add: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#002380',
    marginTop: '.3rem'
  },
  buttonDiv: {
    textAlign: 'right'
  },
  save: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem',
    minWidth: '145px'
  },
  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'Capitalize',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '145px'
  },
  error: {
    fontSize: 14,
    color: 'red',
    margin: 5
  }
}));

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 'none',
    padding: '7px 9px'
  })
};

const NewFeedback = () => {
  const [options, setOptions] = useState([]);
  const [since, setSince] = useState(null);
  const [peers, setPeers] = useState([]);
  const [methodologies, setMethodologies] = useState([]);
  const [opinionOv, setOpinionOv] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorSend, setErrorSend] = useState(false);
  const [errorPeer, setErrorPeer] = useState('');
  const [executionStrategy, setExecutionStrategy] = usePersistedState(
    'executionStrategy',
    5
  );
  const [financialPosition, setFinancialPosition] = usePersistedState(
    'financialPosition',
    3
  );
  const [qualityManagement, setQualityManagement] = usePersistedState(
    'qualityManagement',
    7
  );

  const [strengths, setStrengths] = usePersistedState('strengths', '');
  const [strength, setStrength] = usePersistedState('strength', '');
  const [opinionOnValuation, setOpinionOnValuation] = usePersistedState(
    'opinionOnValuation',
    ''
  );
  const [weaknesses, setWeaknesses] = usePersistedState('weaknesses', '');
  const [weakness, setWeakness] = usePersistedState('weakness', '');
  const [challenges, setChallenges] = usePersistedState('challenges', []);
  const [mngChallenge, setMngChallenge] = usePersistedState(
    'mng_challenge',
    ''
  );
  const [positiveIov, setPositiveIov] = usePersistedState('positive_iov', []);
  const [negativeIov, setNegativeIov] = usePersistedState('negative_iov', []);
  const [positiveInfluence, setPositiveInfluence] = usePersistedState(
    'positive_influence',
    ''
  );
  const [negativeInfluence, setNegativeInfluence] = usePersistedState(
    'negative_influence',
    ''
  );
  const [riskFactors, setRiskFactors] = usePersistedState('risk_factors', []);
  const [riskFactor, setRiskFactor] = usePersistedState('risk_factor', '');
  const [valuationMethodos, setValuationMethodos] = usePersistedState(
    'valuationMethodos',
    []
  );
  const classes = useStyles();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const peersFetch = await axios.get(
          'http://drivee.localhost/api/feedbacks/peers'
        );
        const methodologiesFetch = await axios.get(
          'http://drivee.localhost/api/feedbacks/methodologies'
        );

        const opinionOvFetch = await axios.get(
          'http://drivee.localhost/api/feedbacks/opiniononvaluation'
        );

        setPeers(peersFetch.data.data);
        setMethodologies(methodologiesFetch.data.data);
        setOpinionOv(opinionOvFetch.data.data);

        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const onKeyPressStrength = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setStrengths([...strengths, { name: strength }]);
      setStrength('');
    }
  };

  const onKeyPressWeakness = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setWeaknesses([...weaknesses, { name: weakness }]);
      setWeakness('');
    }
  };

  const onKeyPressChallenge = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setChallenges([...challenges, { name: mngChallenge }]);
      setMngChallenge('');
    }
  };

  const onKeyPressPositive = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setPositiveIov([...positiveIov, { name: positiveInfluence }]);
      setPositiveInfluence('');
    }
  };

  const onKeyPressNegative = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setNegativeIov([...negativeIov, { name: negativeInfluence }]);
      setNegativeInfluence('');
    }
  };

  const onKeyPressRisk = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      setRiskFactors([...riskFactors, { name: riskFactor }]);
      setRiskFactor('');
    }
  };

  const onClickDeleteStrength = (str) => {
    setStrengths(strengths.filter((st) => st.name !== str));
  };

  const onClickDeleteWeakness = (wkn) => {
    setWeaknesses(weaknesses.filter((wk) => wk.name !== wkn));
  };

  const onClickDeleteChallenge = (chlg) => {
    setChallenges(challenges.filter((chal) => chal.name !== chlg));
  };

  const onClickDeletePositive = (posInf) => {
    setPositiveIov(positiveIov.filter((pos) => pos.name !== posInf));
  };

  const onClickDeleteNegative = (negInf) => {
    setNegativeIov(negativeIov.filter((neg) => neg.name !== negInf));
  };

  const onClickDeleteRisk = (riskFac) => {
    setRiskFactors(riskFactors.filter((rsk) => rsk.name !== riskFac));
  };

  const onSelectOption = (e) => {
    console.log(e);
    if (options.includes(e.label)) {
      setErrorPeer('Peer already added!');
    } else {
      setErrorPeer('');
      setOptions([...options, e.label]);
    }
  };

  const onClickDelete = (option) => {
    const updatedOptions = options.filter((opt) => opt !== option);
    setOptions(updatedOptions);
  };

  const handleSaveFeedback = async () => {
    // setIsLoading(true);
    const feedbackObj = {
      sent: false,
      feedback_informations: {
        execution_of_strategy: 24,
        financial_position: 23,
        quality_of_management: 23,
        qom_comment: 'test',
        opinion_on_value: 12,
        oovalue_comment: 'michel',
        strengths: 'test',
        weaknesses: 'test',
        management_challenges: 'test',
        influence_on_valuation: 'test',
        risk_factors_appreciaiton: 'test',
        additional_comment: 'test'
      },
      peer_investments: [
        {
          date_of_peer_investment: '2018-09-22T12:42:31Z',
          peer_id: 2
        },
        {
          date_of_peer_investment: '2018-09-22T12:42:31Z',
          peer_id: 1
        },
        {
          date_of_peer_investment: '2018-09-22T12:42:31Z',
          peer_id: 4
        },
        {
          date_of_peer_investment: '2018-09-22T12:42:31Z',
          peer_id: 3
        }
      ],
      valuation_methodologies: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        },
        {
          id: 4
        },
        {
          id: 5
        },
        {
          id: 6
        },
        {
          id: 7
        },
        {
          id: 9
        },
        {
          id: 8
        }
      ]
    };
    try {
      const sendedFeedback = await axios.post(
        'http://airbnb.localhost/api/feedbacks',
        feedbackObj
      );
      setIsLoading(false);
      console.log('Feedback sent!..', sendedFeedback);
    } catch (error) {
      setErrorSend(error);
      setIsLoading(false);
    }
  };

  const handleSendFeedback = () => {
    console.log('todo');
  };

  return (
    <div className={classes.container}>
      <div className={classes.textContainer}>
        <Typography className={classes.text} color="initial" variant="p">
          Please fill in the following key questions in order to fully assess
          your appreciation of the investment case. You can also solicit a
          meeting with the company and its top management that could take place
          physically or via video-conference.
        </Typography>
        <br />
        <br />
        <Typography className={classes.text} color="initial" variant="p">
          We represent and certify that this information will be kept
          confidential to other investors and third parties to the exclusion of
          company's advisors that are also bound by a non-disclosure agreement.
        </Typography>
      </div>
      <Paper className={classes.paperContainer}>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Execution of strategy
          </Typography>
          <Typography className={classes.instructions}>
            Please rate management key strategic decisions communication and
            execution:
          </Typography>
          <Rating
            high="High quality"
            low="Low quality"
            onChange={(e, newValue) => setExecutionStrategy(newValue)}
            value={executionStrategy}
          />
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Financial position
          </Typography>
          <Typography className={classes.instructions}>
            Please rate management key strategic decisions communication and
            execution:
          </Typography>
          <Rating
            high="Strong"
            low="Weak"
            onChange={(e, newValue) => setFinancialPosition(newValue)}
            value={financialPosition}
          />
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Quality of management
          </Typography>
          <Typography className={classes.instructions}>
            Please rate management key strategic decisions communication and
            execution:
          </Typography>
          <Rating
            high="High quality"
            low="Low quality"
            onChange={(e, newValue) => setQualityManagement(newValue)}
            value={qualityManagement}
          />
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Opinion on valuation proposed
          </Typography>
          <RadioOptions
            handleChange={(e) => setOpinionOnValuation(e.target.value)}
            options={opinionOv.map((oov) => oov.name)}
            value={opinionOnValuation}
          />
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Strenghts & weaknesses
          </Typography>
          <div>
            <Typography
              className={classes.strweak}
              color="initial"
              variant="h6">
              Strenghts
            </Typography>
            <FormControl className={classes.textField} variant="outlined">
              <OutlinedInput
                endAdornment={
                  <InputAdornment position="end">
                    <MicIcon />
                  </InputAdornment>
                }
                id="outlined-adornment-valuationWhy"
                inputProps={{
                  'aria-label': 'strengths'
                }}
                labelWidth={0}
                multiline={strength}
                name="strengths"
                onChange={(e) => setStrength(e.target.value)}
                onKeyPress={onKeyPressStrength}
                rows={1}
                rowsMax={2}
                value={strength}
              />
            </FormControl>
            {strengths.length > 0 && (
              <StrWeakTable
                onClickDelete={onClickDeleteStrength}
                strweak={strengths}
              />
            )}
          </div>
          <br />
          <div>
            <Typography
              className={classes.strweak}
              color="initial"
              variant="h6">
              Weaknesses
            </Typography>
            <FormControl className={classes.textField} variant="outlined">
              <OutlinedInput
                endAdornment={
                  <InputAdornment position="end">
                    <MicIcon />
                  </InputAdornment>
                }
                id="outlined-adornment-valuationWhy"
                inputProps={{
                  'aria-label': 'weakness'
                }}
                labelWidth={0}
                multiline={weakness}
                name="weakness"
                onChange={(e) => setWeakness(e.target.value)}
                onKeyPress={onKeyPressWeakness}
                rows={1}
                rowsMax={2}
                value={weakness}
              />
            </FormControl>
            {weaknesses.length > 0 && (
              <StrWeakTable
                onClickDelete={onClickDeleteWeakness}
                strweak={weaknesses}
              />
            )}
          </div>
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Management challenges
          </Typography>
          <Typography className={classes.instructions}>
            Please list the few challenges that the management of the issuer
            would be facing:
          </Typography>
          <div>
            <FormControl className={classes.textField} variant="outlined">
              <OutlinedInput
                endAdornment={
                  <InputAdornment position="end">
                    <MicIcon />
                  </InputAdornment>
                }
                id="outlined-adornment-mngChal"
                inputProps={{
                  'aria-label': 'mng_challenge'
                }}
                labelWidth={0}
                multiline={mngChallenge}
                name="mng_challenge"
                onChange={(e) => setMngChallenge(e.target.value)}
                onKeyPress={onKeyPressChallenge}
                rows={1}
                rowsMax={2}
                value={mngChallenge}
              />
            </FormControl>
            {challenges.length > 0 && (
              <InfluenceValuationTable
                onClickDelete={onClickDeleteChallenge}
                options={challenges}
              />
            )}
          </div>
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Influence on valuation
          </Typography>
          <Typography className={classes.instructions}>
            Please list key factors that could positively or negatively impact
            valuation:
          </Typography>
          <br />
          <div>
            <div>
              <Typography
                className={classes.strweak}
                color="initial"
                variant="h6">
                Positive impact
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-posInf"
                  inputProps={{
                    'aria-label': 'positive_influence'
                  }}
                  labelWidth={0}
                  multiline={positiveInfluence}
                  name="positive_influence"
                  rows={1}
                  rowsMax={2}
                  value={positiveInfluence}
                  onChange={(e) => setPositiveInfluence(e.target.value)}
                  onKeyPress={onKeyPressPositive}
                />
              </FormControl>

              {positiveIov.length > 0 && (
                <InfluenceValuationTable
                  options={positiveIov}
                  onClickDelete={onClickDeletePositive}
                />
              )}
            </div>
            <br />
            <div>
              <Typography
                className={classes.strweak}
                color="initial"
                variant="h6">
                Negative impact
              </Typography>
              <FormControl className={classes.textField} variant="outlined">
                <OutlinedInput
                  endAdornment={
                    <InputAdornment position="end">
                      <MicIcon />
                    </InputAdornment>
                  }
                  id="outlined-adornment-negInf"
                  inputProps={{
                    'aria-label': 'negative_influence'
                  }}
                  labelWidth={0}
                  multiline={negativeInfluence}
                  name="negative_influence"
                  rows={1}
                  rowsMax={2}
                  value={negativeInfluence}
                  onChange={(e) => setNegativeInfluence(e.target.value)}
                  onKeyPress={onKeyPressNegative}
                />
              </FormControl>

              {negativeIov.length > 0 && (
                <InfluenceValuationTable
                  options={negativeIov}
                  onClickDelete={onClickDeleteNegative}
                />
              )}
            </div>
          </div>
        </div>
        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Valuation methodologies
          </Typography>
          <Typography className={classes.instructions}>
            Select the top 3 methodologies to best evaluate the issuer:
          </Typography>
          <Select
            closeMenuOnScroll
            isMulti
            closeMenuOnSelect={false}
            components={animatedComponents}
            options={
              methodologies &&
              methodologies.map((metho) => createOption(metho.name))
            }
            placeholder="select..."
            styles={customStyles}
            onChange={(e) => setValuationMethodos(e)}
          />
        </div>

        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Have you invested in peers?
          </Typography>
          <div>
            <Typography
              className={classes.strweak}
              color="initial"
              variant="h6">
              Select Peer
            </Typography>
            <Select
              closeMenuOnSelect
              components={animatedComponents}
              onChange={onSelectOption}
              options={peers && peers.map((peer) => createOption(peer.name))}
              placeholder="type here..."
              styles={customStyles}
            />
            {options.length > 0 && (
              <PeersTable
                onClickDelete={onClickDelete}
                options={options}
                setSince={(date) => setSince(moment(date).format('MMMM YYYY'))}
                since={since}
              />
            )}
            {errorPeer && <p className={classes.error}>{errorPeer}</p>}
          </div>
        </div>

        <div className={classes.valueInfo}>
          <Typography className={classes.desc} color="initial" variant="h1">
            Your appreciation of the risk factors
          </Typography>
          <Typography className={classes.instructions}>
            Please list the risk factors that in your view are the most relevant
          </Typography>
          <div>
            <FormControl className={classes.textField} variant="outlined">
              <OutlinedInput
                endAdornment={
                  <InputAdornment position="end">
                    <MicIcon />
                  </InputAdornment>
                }
                id="outlined-adornment-rskFact"
                inputProps={{
                  'aria-label': 'risk_factor'
                }}
                labelWidth={0}
                multiline={riskFactor}
                name="risk factor"
                onChange={(e) => setRiskFactor(e.target.value)}
                onKeyPress={onKeyPressRisk}
                rows={1}
                rowsMax={2}
                value={riskFactor}
              />
            </FormControl>
            {riskFactors.length > 0 && (
              <InfluenceValuationTable
                onClickDelete={onClickDeleteRisk}
                options={riskFactors}
              />
            )}
          </div>
        </div>
        <div className={classes.buttonDiv}>
          <Button
            className={classes.save}
            color="primary"
            onClick={handleSaveFeedback}
            variant="outlined">
            {isLoading ? 'Saving...' : 'Save answers'}
          </Button>
          <Button
            className={classes.send}
            color="primary"
            onClick={handleSendFeedback}
            variant="contained">
            {isLoading ? 'Sending...' : 'Send feedback'}
          </Button>
          {errorSend && <p className={classes.error}>{errorSend}</p>}
          {!isLoading && (
            <PDFDownloadLink
              document={
                <FeedbackPDF
                  challenges={challenges}
                  companyLogo={logoDrivee}
                  executionStrategy={executionStrategy}
                  financialPosition={financialPosition}
                  negativeIov={negativeIov}
                  opinionOnValuation={opinionOnValuation}
                  peers={options}
                  positiveIov={positiveIov}
                  qualityManagement={qualityManagement}
                  riskFactors={riskFactors}
                  strengths={strengths}
                  valuationMethodos={valuationMethodos}
                  weaknesses={weaknesses}
                />
              }
              fileName="feedback-summary.pdf"
              style={{
                textDecoration: 'none',
                padding: '10.5px 16px',
                marginLeft: '1rem',
                color: '#FFF',
                backgroundColor: '#002380',
                fontFamily: 'PT sans',
                fontSize: '16px',
                textTransform: 'Capitalize',
                fontWeight: 'bold',
                borderRadius: 0,
                minWidth: '145px'
              }}>
              Download Feedback
            </PDFDownloadLink>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default NewFeedback;
